import React from 'react';
import PropTypes from 'prop-types';
import { Badge, BadgeList } from './Badge';

// This component renders a list of the currently applied report filters to the ui
function AppliedFilters({ filters, setFilters, defaultFilterState }) {
  // Alerts and appointments are the only filters whose values are booleans rather than arrays of strings
  const checkedFilters = Object.keys(filters).filter((filterKey) => {
    return (
      (filterKey === 'ds_alert_sent' || filterKey === 'ds_appt_set') && filters[filterKey] === true
    );
  });

  function uncheckFilter(filterName) {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: defaultFilterState[filterName],
    }));
  }

  const selectedFilters = Object.keys(filters).filter(
    (filterKey) =>
      Array.isArray(filters[filterKey]) && filterKey !== 'domains' && filters[filterKey].length > 0
  );

  // Removes selected filter from array
  function removeFilter(filterName, filterValue) {
    const newFilterValues = filters[filterName].filter((el) => el !== filterValue);
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: newFilterValues,
    }));
  }

  if (selectedFilters.length === 0 && checkedFilters.length === 0) {
    return null;
  } else {
    return (
      <BadgeList title='Applied filters'>
        {checkedFilters.map((filter) => (
          <Badge
            label={filter === 'ds_alert_sent' ? 'Alerts' : 'Appointments'}
            removable
            onRemove={() => uncheckFilter(filter)}
            key={filter}
          />
        ))}
        {selectedFilters.map((filterName) => {
          return filters[filterName].map((selectedFilter) => (
            <Badge
              label={selectedFilter.label}
              key={selectedFilter.value}
              removable
              onRemove={() => removeFilter(filterName, selectedFilter)}
            />
          ));
        })}
      </BadgeList>
    );
  }
}

AppliedFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  defaultFilterState: PropTypes.object.isRequired,
};

export default AppliedFilters;
